import Policy from './Policy.i18n';

export default Policy
export { Policy as Base }